import type { RequestFn } from '../client';
import type {
  MerchantCheckoutBrowserInfoResponse,
  UpdateCheckoutBrowserInfoScopeRequest,
} from '../types';

/** Merchant control of the five extra device fields collected on hosted-checkout confirm. */
export class CheckoutBrowserInfo {
  constructor(private readonly request: RequestFn) {}

  /** Read the merchant's own setting and effective collection policy. */
  async retrieve(merchantId: string): Promise<MerchantCheckoutBrowserInfoResponse> {
    return this.request('GET', '/checkout-browser-info', { query: { merchant_id: merchantId } });
  }

  /** Replace the merchant setting. An admin refusal still wins; changes are audited. */
  async update(
    merchantId: string,
    body: UpdateCheckoutBrowserInfoScopeRequest,
  ): Promise<MerchantCheckoutBrowserInfoResponse> {
    return this.request('PUT', '/checkout-browser-info', {
      query: { merchant_id: merchantId },
      body,
    });
  }
}
